import { type ReactNode } from 'react';
import { Inbox } from 'lucide-react';

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}): ReactNode {
  return (
    <div className="py-xl text-center">
      <Inbox size={32} className="mx-auto text-text-tertiary" />
      <p className="mt-md text-sm text-text-secondary">{title}</p>
      {description && (
        <p className="mt-1 text-xs text-text-tertiary">{description}</p>
      )}
      {action && <div className="mt-md">{action}</div>}
    </div>
  );
}
